/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_Download_Report_JsonInputs */



/**
* | output |
* | --- |
* | "Download Report (JSON)" |
*
* @param {Decks_Download_Report_JsonInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_download_report_json = /** @type {((inputs?: Decks_Download_Report_JsonInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Download_Report_JsonInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Télécharger le rapport (JSON)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargar informe (JSON)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Baixar relatório (JSON)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scarica rapporto (JSON)")
	return /** @type {LocalizedString} */ ("Download Report (JSON)")
});